﻿import { useState, useEffect } from "react";
import { Modal, Button, InputGroup, Form } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import { decimalValidateNew, formatMilesDecimalNew, formatUnitMeasure } from "@/services/Utils";

import { useCriticalStock, useCriticalStockSave } from "@/hooks/products/useCriticalStock";
import Fetching from "@/components/Fetching/Fetching";

const ProductCriticalStock = () => {
	const { addToast } = useToasts();
	const navigate = useNavigate();
	const { option, product_id } = useParams();

	const [stock, setStock] = useState("");

	const { data, isLoading } = useCriticalStock(product_id, option);
	const { mutate, isLoading: isLoadingSave } = useCriticalStockSave();

	useEffect(() => {
		if (data && data.stock) {
			setStock(data.stock);
		}
	}, [data]);

	const handleClose = () => {
		navigate(-1);
	};

	const handleSave = () => {
		mutate(
			{ product_id, stock },
			{
				onSuccess: () => {
					addToast("Stock crítico actualizado", { appearance: "success", autoDismiss: true });
					handleClose();
				},
			},
		);
	};

	return (
		<Modal show={option === "stock_critico" && product_id ? true : false} onHide={handleClose} backdrop="static" keyboard={false}>
			<Modal.Header closeButton>
				<Modal.Title style={{ fontSize: "1em" }}>
					<span style={{ fontWeight: "400" }}> Ingresa el stock crítico para el producto</span> <br /> {data && data.product}
				</Modal.Title>
			</Modal.Header>

			{isLoading || isLoadingSave ? (
				<Fetching newStyles={{ marginTop: "1em", marginBottom: "1em" }} />
			) : (
				<>
					<Modal.Body>
						<InputGroup className="mb-3">
							<Form.Control
								type="text"
								name="stock"
								value={stock ? formatMilesDecimalNew(stock) : ""}
								onChange={(e) => {
									const value = String(e.target.value).replaceAll(".", "");
									setStock(value);
								}}
								onKeyDown={decimalValidateNew}
							/>
							<InputGroup.Text id="stock" style={{ width: "30%" }}>
								{data && formatUnitMeasure(data.unit_measurement)}
							</InputGroup.Text>
						</InputGroup>
					</Modal.Body>
					<Modal.Footer>
						<Button style={{ fontSize: "0.8em" }} variant="danger" onClick={() => handleClose()}>
							CANCELAR
						</Button>
						<Button
							style={{ fontSize: "0.8em" }}
							variant="success"
							onClick={() => {
								handleSave();
							}}
						>
							CONFIRMAR
						</Button>
					</Modal.Footer>
				</>
			)}
		</Modal>
	);
};

export default ProductCriticalStock;
